<div class="container mt-4">
 <ngb-alert
  *ngIf="alert"
  [type]="alert.type"
  (closed)="closeAlert()"
  class="sticky-top"
  style="top: 10px"
>
  <span [innerHTML]="alert.message"></span>
</ngb-alert>
  <app-register-stepper
    [progressData]="getProgressData()"
    [user]="user"
  ></app-register-stepper>

  <div class="row mb-2 account-detail-container">
    <div class="col-12">
      <div class="row mb-3">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <h1 class="text-center">Free pet insurance from <strong>Petplan</strong><sup style="font-size: 16px;">&reg;</sup></h1>
        </div>
      </div>
    </div>
  </div>

  <div class="row main-top">
    <div class="col-md-10 offset-md-1">
      <div class="d-flex justify-content-center">
        <h3 class="mt-5 mb-4 text-center">
          Activate 4 weeks free pet insurance for {{eligiblePet.name}} today!
        </h3>
      </div>
      <p class="mb-1 small-text text-center">
        We've partnered with Petplan, the UK's No.1 pet insurer, to offer you 4 weeks free insurance with all our microchips. <br><br>
        By activating, you will immediately have £4,000 veterinary cover for illness and injury in case the unexpected happens - and there's no catch! <br><br>
        Simply follow the steps below to activate 4 weeks free insurance for {{eligiblePet.name}} and for your details to be shared with Petplan.
      </p>
      <p class="mb-0 mt-4 text-center medium-text">
        Do you want free insurance from Petplan? 
      </p>
      <div class="button-container">
        <div
          class="my-4 d-flex flex-row justify-content-md-start align-items-center ms-2 button-container-content"
        >
          <button
            class="badge yes-button text-white"
            id="{{ petSpecie + '-Yes'}}"
            type="button"
            (click)="openHalfPageDeclaration()"
            [disabled]="loading"
          >
            <fa-icon
              *ngIf="loading"
              [icon]="['fas', 'spinner']"
              [animation]="'spin'"
              class="me-3"
            ></fa-icon>
            <b>Yes</b>, I want free insurance
          </button>
        </div>
        <div
          class="mt-0 d-flex flex-row justify-content-start justify-content-md-start align-items-center ms-2 button-container-content"
        >
          <button
            class="badge no-button no-button-color text-white"
            type="button"
            id="{{ petSpecie + '-No'}}"
            (click)="noToPetInsurance()"
          >
            <b>Not now</b>, I don't want free insurance yet
          </button>
        </div>
      </div>
      <div *ngIf="showPetPlanHalfPage">
        <div class="green-box">
          <p class="mb-1 mt-1 text-center small-text">
            You have received an email form Petplan containing important policy documents to help you understand the cover. Please read these before activating your 4 weeks free insurance.
          </p>
        </div>
        <div class="mt-3">
          <h4>Declaration</h4>
          <ul>
            <li>You don’t currently have a full pet insurance policy or any other Petplan free cover for this pet.</li>
            <li>This product meets your demands and needs as a pet owner who wants free cover for the cost of veterinary treatment for illness and injuries for a period of 4 weeks.</li>
            <li>You, the pet owner, understand that you will have to pay an excess when making a claim for veterinary fees.</li>
          </ul>
          <div class="mb-0">
            <label class="form-check-label d-flex">
              <input
                class="me-3 communication-checkbox"
                id="microchipWasAccurate"
                name="microchipWasAccurate"
                (change)="onDeclarationChange($event, 'microchipWasAccurate')"
                type="checkbox"
              />
              <span>
                <b>The information I provided about myself and my pet, when registering my pet's microchip, was accurate.
                  I understand that if any of the information was incorrect it could affect my pet's cover and whether my claims are paid.</b>
              </span>
            </label>
          </div>
          <div class="mb-0 mt-2">
            <label class="form-check-label d-flex">
              <input
                class="me-3 communication-checkbox"
                id="microchipWasAccurate"
                name="microchipWasAccurate"
                (change)="onDeclarationChange($event, 'noPreExistingConditions')"
                type="checkbox"
              />
              <span>
                <b>I understand that </b>
                <b>pre-existing conditions may not be covered. Pre-existing conditions are any injury that happened or illness that showed symptoms before your policy starts.</b>
              </span>
            </label>
          </div>
        </div>
        <div class="mt-3">
          <h4>Validity Period</h4>
          <div class="medium-text">
            This insurance is valid for a period of 4 weeks from the date of activation. Full terms and conditions have been provided.
          </div>
        </div>
        <div class="mt-3">
          <h4>Using your data </h4>
          <p class="medium-text">
            To ensure {{eligiblePet.name}} continues to have treatment if they were to become ill or injured, 
            Petplan will be in touch with information about extending cover beyond the next 4 weeks by email and SMS. 
            Information you provide Petplan will be held in accordance to their <a href="https://www.petplan.co.uk/privacy-and-legal.html" target="_blank">Privacy and Legal Policy.</a></p>
          <p class="medium-text mb-1">
            If you don't want to receive this by email or text, please change the slide to No.
          </p>
          <div class="d-flex mb-4">
            <div class="medium-text">
              Please contact me
            </div>
            <div class="d-flex justify-content-center align-items-end">
              <div class="yes-no-toggle" [class.active]="isDataUsageAllowed" (click)="toggleYesNo()">
                <div class="toggle-label">{{ isDataUsageAllowed ? 'Yes' : 'No' }}</div>
                <div class="toggle-knob"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="button-container">
              <div class="mt-3 d-flex flex-row justify-content-md-start align-items-center ms-2 button-container-content">
                 <button
                class="btn yes-button yes-button-rounded text-white btn-lg w-100"
                [disabled]="loading || !declarationChecksAllTrue"
                (click)="completeWelcomeGift(true)"
              >
                <fa-icon
                  *ngIf="loading"
                  [icon]="['fas', 'spinner']"
                  [animation]="'spin'"
                  class="me-3"
                ></fa-icon>
                {{ loading ? "Activating" : "Activate Free Cover" }}
              </button>
              </div>
              <div class="mt-3 d-flex flex-row justify-content-start justify-content-md-start align-items-center ms-2 button-container-content">
                <button
                class="btn no-button no-button-rounded text-white btn-lg w-100"
                [disabled]="loading || !declarationChecksAllTrue"
                (click)="completeWelcomeGift(false)"
                >
                  <fa-icon
                    *ngIf="loading"
                    [icon]="['fas', 'spinner']"
                    [animation]="'spin'"
                    class="me-3"
                  ></fa-icon>
                  No, I don’t want free insurance.
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!showPetPlanHalfPage" class="row mt-3 petplan-text">
    <div class="col-md-10 offset-md-1">
      <h4 class="mb-2 text-center">Why take out <span class="blue-text" >Petplan's</span> Free 4 Weeks Veterinary cover?</h4>
      <div class="box-container mt-4">
        <div class="box">
          <div class="box-header">Financial help</div>
          <div class="box-content">
            Petplan can help you cover the cost of vet bills.
          </div>
        </div>
        <div class="box">
          <div class="box-header">No catch</div>
          <div class="box-content">
            No bank details are taken and cover automatically expires after 4 weeks. Unless you decide to continue cover.
          </div>
        </div>
        <div class="box">
          <div class="box-header">Vets choose Petplan</div>
          <div class="box-content">
            Thousands of vets choose to work in partnership with Petplan.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-5 mb-4">
    <div class="col-12 text-center ">
      <div class="note">
        Terms, conditions and excesses apply. Cover may be provided for some pre-existing conditions. <br>
        Petplan ® is the trading name of Pet Plan Ltd (Registered in England No.1282939) and Allianz Insurance plc (Registered in England No. 84638). Registered office: 57 Ladymead,
        Guildford, Surrey, GU1 1DB. Pet Plan Ltd is authorised and regulated by the Financial Conduct Authority. Allianz Insurance plc is authorised by the
        Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority. <br>
        Identicare Limited is an Appointed Representative of Pet Plan Ltd but is not part of the Allianz (UK) Group.   
      </div>
    </div>
  </div>
</div>
